import { useRef } from 'react';
import styled from 'styled-components';
import classNames from 'classnames';
import H4 from 'UIComponents/elements/headings/H4';
import UIIcon from 'UIComponents/icon/UIIcon';
import UIIconButton from 'UIComponents/button/UIIconButton';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { GRID_BREAKPOINT_MEDIUM, GRID_BREAKPOINT_LARGE } from 'HubStyleTokens/sizes';
import { EERIE } from 'HubStyleTokens/colors';

// @ts-expect-error Untyped import
import { useVerticalFitPagination } from '../../../hooks/paginationHooks';
// @ts-expect-error Untyped import
import checkUrl from 'bender-url!../../../../images/high-success.svg';
import { useAchievementLessons, getMetadataLanguageFallback } from '../achievementQueries';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const TickList = styled.div.withConfig({
  displayName: "CurriculumInfo__TickList",
  componentId: "sc-1i7vqfh-0"
})(["position:relative;ul{list-style:none;padding:0;margin-bottom:0;@media (min-width:", "){position:absolute;}}li{margin-bottom:14px;display:flex;align-items:top;&::before{content:'';margin-right:12px;height:24px;flex:0 0 24px;background:", ";mask-image:url('", "');mask-size:15px 15px;mask-repeat:no-repeat;mask-position:4px 4px;}&.unshown{@media (min-width:", "){visibility:hidden;}}}"], GRID_BREAKPOINT_LARGE, EERIE, checkUrl, GRID_BREAKPOINT_MEDIUM);
const margin1 = '32px';
const margin2 = '48px';
const CurriculumWrapper = styled.div.withConfig({
  displayName: "CurriculumInfo__CurriculumWrapper",
  componentId: "sc-1i7vqfh-1"
})(["margin:", " 0;height:calc(100% - 2 * ", ");position:relative;@media (min-width:", "){margin-left:32px;}@media (min-width:", "){margin-left:48px;margin-top:", ";display:flex;align-items:center;height:calc(100% - (", " + ", "));}"], margin1, margin1, GRID_BREAKPOINT_MEDIUM, GRID_BREAKPOINT_LARGE, margin2, margin1, margin2);
const ArrowButton = styled(({
  className,
  dir,
  hasDir,
  proceed
}) => /*#__PURE__*/_jsx(UIIconButton, {
  className: classNames(className, dir < 0 && "back", dir > 0 && "forward"),
  color: EERIE,
  disabled: !hasDir[dir],
  onClick: () => proceed(dir),
  use: "transparent",
  children: /*#__PURE__*/_jsx(UIIcon, {
    name: dir > 0 ? 'right' : 'left',
    size: 24
  })
})).withConfig({
  displayName: "CurriculumInfo__ArrowButton",
  componentId: "sc-1i7vqfh-2"
})(["&.back{margin:0 32px 0 -32px;}&.forward{margin-left:auto;}"]);
const CurriculumHeading = styled(H4).withConfig({
  displayName: "CurriculumInfo__CurriculumHeading",
  componentId: "sc-1i7vqfh-3"
})(["@media (max-width:", "){text-align:center;}"], GRID_BREAKPOINT_MEDIUM);
const ListWrapper = styled.div.withConfig({
  displayName: "CurriculumInfo__ListWrapper",
  componentId: "sc-1i7vqfh-4"
})(["@media (min-width:", "){flex-grow:1;align-self:start;}"], GRID_BREAKPOINT_LARGE);
const CurriculumInfo = ({
  publicId,
  language
}) => {
  const lessons = useAchievementLessons(publicId);
  const container = useRef(null);
  const ul = useRef(null);
  const {
    hasPartitions,
    hasDir,
    proceed
  } = useVerticalFitPagination(ul, container);
  return /*#__PURE__*/_jsxs(CurriculumWrapper, {
    ref: container,
    children: [hasPartitions && /*#__PURE__*/_jsx(ArrowButton, {
      dir: -1,
      hasDir: hasDir,
      proceed: proceed
    }), /*#__PURE__*/_jsxs(ListWrapper, {
      children: [/*#__PURE__*/_jsx(CurriculumHeading, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "learningCenter.certification.curriculumCompleted"
        })
      }), /*#__PURE__*/_jsx(TickList, {
        children: /*#__PURE__*/_jsx("ul", {
          ref: ul,
          children: lessons && lessons.map((lesson, i) => /*#__PURE__*/_jsx("li", {
            className: "unshown",
            children: /*#__PURE__*/_jsx("span", {
              children: getMetadataLanguageFallback(lesson.metadata, language).name
            })
          }, i))
        })
      })]
    }), hasPartitions && /*#__PURE__*/_jsx(ArrowButton, {
      dir: 1,
      hasDir: hasDir,
      proceed: proceed
    })]
  });
};
export default CurriculumInfo;